// extracted by mini-css-extract-plugin
export default {"container":"PageInPopup__container--20-","error":"PageInPopup__error--3IK"};